import { render, staticRenderFns } from "./associatedObjects.vue?vue&type=template&id=edfaa74c&scoped=true"
import script from "./associatedObjects.vue?vue&type=script&lang=js"
export * from "./associatedObjects.vue?vue&type=script&lang=js"
import style0 from "./associatedObjects.vue?vue&type=style&index=0&id=edfaa74c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfaa74c",
  null
  
)

export default component.exports